import { min } from "lodash";

export const QUERY_WINDOW_PAGE_DAYS = 7;

export type AvailabilityQueryWindow = {
  requestStartDayOffset: number;
  requestEndDayOffset: number;
  loadedEndDayOffset: number;
};

export const getInitialAvailabilityQueryWindow = (
  dayDifference: number,
  bookingWindowDays: number
): AvailabilityQueryWindow => {
  const initialEndDayOffset =
    min([dayDifference + QUERY_WINDOW_PAGE_DAYS, bookingWindowDays]) ?? 0;

  return {
    requestStartDayOffset: 0,
    requestEndDayOffset: initialEndDayOffset,
    loadedEndDayOffset: initialEndDayOffset,
  };
};

export const getNextAvailabilityQueryWindow = (
  currentWindow: AvailabilityQueryWindow,
  bookingWindowDays: number
): AvailabilityQueryWindow => {
  if (currentWindow.loadedEndDayOffset >= bookingWindowDays) {
    return currentWindow;
  }

  const nextRequestStartDayOffset = min([
    currentWindow.loadedEndDayOffset + 1,
    bookingWindowDays,
  ]);
  const nextLoadedEndDayOffset = min([
    currentWindow.loadedEndDayOffset + QUERY_WINDOW_PAGE_DAYS,
    bookingWindowDays,
  ]);

  return {
    requestStartDayOffset: nextRequestStartDayOffset ?? 0,
    requestEndDayOffset: nextLoadedEndDayOffset ?? 0,
    loadedEndDayOffset: nextLoadedEndDayOffset ?? 0,
  };
};

export const hasReachedAvailabilityBookingWindow = (
  currentWindow: AvailabilityQueryWindow,
  bookingWindowDays: number
) => currentWindow.loadedEndDayOffset >= bookingWindowDays;

type Identifiable = { id: string };

export const mergeAvailabilitySlots = <T extends Identifiable>(
  existingSlots: T[],
  incomingSlots: T[]
) => {
  const existingSlotIds = new Set(existingSlots.map((slot) => slot.id));
  const uniqueIncomingSlots = incomingSlots.filter(
    ({ id }) => !existingSlotIds.has(id)
  );

  return [...existingSlots, ...uniqueIncomingSlots];
};
